var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKightsFeatureModalIcon = function SvgKightsFeatureModalIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38.5,
    height: 38.5,
    rx: 3.208,
    fill: "#6FCF97"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.823 11.688a.802.802 0 0 1 0 1.134 9.092 9.092 0 0 0 0 12.855.803.803 0 0 1-1.135 1.134c-4.176-4.176-4.176-10.947 0-15.123a.802.802 0 0 1 1.135 0Zm13.989 0c4.176 4.176 4.176 10.947 0 15.124a.802.802 0 0 1-1.134-1.134 9.09 9.09 0 0 0 0-12.856.802.802 0 1 1 1.134-1.134Zm-10.965 3.024a.802.802 0 0 1 0 1.134 4.81 4.81 0 0 0 0 6.807.802.802 0 0 1-1.134 1.134 6.416 6.416 0 0 1 0-9.075.802.802 0 0 1 1.134 0Zm7.94 0a6.417 6.417 0 0 1 0 9.075.8.8 0 0 1-1.319-.253.801.801 0 0 1 .185-.881 4.812 4.812 0 0 0 0-6.806.802.802 0 0 1 1.134-1.133v-.002Zm-4.537 2.934a1.604 1.604 0 1 1 0 3.209 1.604 1.604 0 0 1 0-3.21Z",
    fill: "#fff"
  })));
};
export default SvgKightsFeatureModalIcon;